/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { CableTrayFamilyInformationModule } from './cable-tray-family-information.module';
export { CableTrayFamilyInformation } from './cable-tray-family-information.component';